/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Seniority_EntryInputs */

const en_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const de_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einsteiger`)
};

const fr_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant`)
};

const es_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante`)
};

const it_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const nl_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const pl_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const fi_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloittelija`)
};

const da_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior`)
};

const sv_salary_seniority_entry = /** @type {(inputs: Salary_Seniority_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junior`)
};

/**
* | output |
* | --- |
* | "Entry" |
*
* @param {Salary_Seniority_EntryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_seniority_entry = /** @type {((inputs?: Salary_Seniority_EntryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Seniority_EntryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_seniority_entry(inputs)
	if (locale === "fr") return fr_salary_seniority_entry(inputs)
	if (locale === "es") return es_salary_seniority_entry(inputs)
	if (locale === "it") return it_salary_seniority_entry(inputs)
	if (locale === "nl") return nl_salary_seniority_entry(inputs)
	if (locale === "pl") return pl_salary_seniority_entry(inputs)
	if (locale === "fi") return fi_salary_seniority_entry(inputs)
	if (locale === "da") return da_salary_seniority_entry(inputs)
	if (locale === "sv") return sv_salary_seniority_entry(inputs)
	return en_salary_seniority_entry(inputs)
});